import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getCurrentTechnicianId,
  getForm,
  getInvalidFields,
  getShowInviteTechnicianModal,
  getTechnicianModalState,
  getValidationMessage,
} from 'selectors/admin/team/contractor-team';
import {
  setShowInviteTechnicianModal,
  updateFormValue,
  deleteTechnicianRequest,
  submitFormRequestForTechnician,
} from 'actions/admin/team/contractor-team';
import InviteTechnicianModal, {
  TechnicianModalState,
} from 'components/shared/modal/InviteTechnicianModal';
import { formatPhoneNumber } from 'services/utils/text-util';

class ContractorTeamTechnicianModalContainer extends Component {
  handleClose = () => {
    this.props.dispatch(setShowInviteTechnicianModal(false));
  };

  handleSubmit = () => {
    const { form, dispatch, currentTechnicianId } = this.props;
    dispatch(submitFormRequestForTechnician(form, currentTechnicianId));
  };

  handleAttributeChange = (attribute, value) => {
    this.props.dispatch(updateFormValue(attribute, value));
  };

  handleEdit = () => {
    this.props.dispatch(
      setShowInviteTechnicianModal(true, TechnicianModalState.EDIT)
    );
  };

  handleDeleteConfirmation = (result) => {
    if (result) {
      this.props.dispatch(
        deleteTechnicianRequest(this.props.currentTechnicianId)
      );
    }
  };

  render() {
    const technicianFormField = [
      {
        attribute: 'firstName',
        label: 'First Name*',
        renderer: 'input',
      },
      {
        attribute: 'lastName',
        label: 'Last Name',
        renderer: 'input',
      },
      {
        attribute: 'email',
        label: 'Email',
        renderer: 'input',
      },
      {
        attribute: 'phoneNumber',
        formatter: formatPhoneNumber,
        label: 'Phone Number',
        renderer: 'input',
      },
    ];

    return (
      <div>
        <InviteTechnicianModal
          form={technicianFormField}
          invalidFields={this.props.invalidFields}
          modalState={this.props.technicianModalState}
          show={this.props.showInviteTechnicianModal}
          values={this.props.form}
          validationMessage={this.props.validationMessage}
          onAttributeChange={this.handleAttributeChange}
          onClose={this.handleClose}
          onDeleteConfirmation={this.handleDeleteConfirmation}
          onEdit={this.handleEdit}
          onSubmit={this.handleSubmit}
        />
      </div>
    );
  }
}

export default connect((state) => {
  return {
    currentTechnicianId: getCurrentTechnicianId(state),
    form: getForm(state),
    invalidFields: getInvalidFields(state),
    showInviteTechnicianModal: getShowInviteTechnicianModal(state),
    technicianModalState: getTechnicianModalState(state),
    validationMessage: getValidationMessage(state),
  };
})(ContractorTeamTechnicianModalContainer);



// WEBPACK FOOTER //
// ./src/components/admin/team/ContractorTeamTechnicianModalContainer.js